<template>
    <div class="smr-choice-group" :class="{ 'as-rows' : showInRows, 'as-list': showAsList }">
        <el-checkbox-group v-model="groupData" @change="checkboxGroupChangeHandler" :min="minAmount" :max="maxAmount ? maxAmount : options.length" v-if="!this.singleChoice" ref="checkboxGroup">
            <component :is="option.tooltip ? 'SmrTooltip' : 'div'" :zIndex="true" :content="option.tooltip" position="top" class="smr-choice-group__checkbox" :class="{'smr-choice-group__checkbox--safari': isSafari}" v-for="option in options" :key="option.value">
                <!-- @TODO remove v-if="!option.hidden" when OCC Partner is implemented --> 
                <el-checkbox :label="option.value" border :class="[{'has-icon': option.image}, { 'increased-padding' : option.increasedSpace }]" :disabled="option.disabled" v-if="!option.hidden" @change="checkboxChangeHandler(option, $event)"> 
                    <img :src="option.image" v-if="option.image" class="smr-choice-group__item__image"/> 
                    <icon v-if="option.icon"  class="smr-choice-group__item__icon">
                        <PlugIcon v-if="specialIconType && specialIconType === 'plugIcon'" :icon="option.icon" />
                        <component v-else :is="option.icon" />
                    </icon>
                    <span class="smr-choice-group__item__text">
                        <span class="copy" v-html="option.label"></span>
                        <span class="sublabel copy-light-small" v-if="option.sublabel">{{ option.sublabel }}</span>
                    </span>
                    <SmrTooltip content="Ziehen, um Reihenfolge zu ändern" position="bottom-start" :zIndex="true">
                        <icon class="smr-choice-group__item__drag-handle" v-if="sortable" :width="20" :height="20" view-box="0 0 20 20"><IconDragHandle /></icon>
                    </SmrTooltip>
                    <!-- <icon class="smr-choice-group__item__drag-handle" v-if="sortable" :width="20" :height="20" view-box="0 0 20 20"><IconDragHandle /></icon> -->
                    <div v-if="option.additionalActions" class="smr-choice-group__item__actions" @click="actionsClickHandler">
                        <MoreActions :actions="option.additionalActions" :emitGeneralEvent="true" @actionClick="actionsOptionClickHandler($event, option.value)" :tooltips="tooltipsContent"/>
                    </div>
                </el-checkbox>
            </component>    
        </el-checkbox-group>
        <!-- Unfortunately we must duplicate the code instead of using component :is="" approach because el-radio-group doesn't support it -->
        <el-radio-group v-model="groupData" @change="checkboxGroupChangeHandler" v-else>
             <div class="smr-choice-group__radio" :class="{'smr-choice-group__radio--radio': isSafari}" v-for="option in options" :key="option.value">
                <el-radio :label="option.value" border :class="{'has-icon': option.image}" @change="checkboxChangeHandler(option, $event)">
                    <img :src="option.image" v-if="option.image" class="smr-choice-group__item__image"/>
                    <span class="smr-choice-group__item__text">
                        <span class="copy">{{ option.label }}</span>
                        <span class="sublabel copy-light-small" v-if="option.sublabel">{{ option.sublabel }}</span>
                    </span>
                </el-radio>
            </div>    
        </el-radio-group>
    </div>
</template>

<script>
import Sortable from 'sortablejs';
import { sortArrayByObject } from '@/utils/sorting';

import Icon from '@/components/Icon.vue'
import IconDragHandle from '@components/icons/IconDragHandle.vue';
import PlugIcon from '@/components/PlugIcon.vue'
import MoreActions from '@/components/MoreActions.vue'
import SmrTooltip from '@/components/SmrTooltip.vue'
import safariBrowser from '@/utils/browser-type';
import { trackEvent, trackGa4Event } from '@/utils/tracking'

export default {
    components: {
        Icon,
        IconDragHandle,
        MoreActions,
        SmrTooltip,
        PlugIcon,
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        values: {
            type: [Object, Array, String],
            default: () => {}
        },
        minAmount: {
            type: Number,
            default: 0
        },
        maxAmount: {
            type: [Number, Boolean],
            default: false
        },
        outputArray: {
            type: Boolean,
            default: false
        },
        singleChoice: {
            type: Boolean,
            default: false
        },
        singleChoiceCheckbox: {
            type: Boolean,
            default: false
        },
        keepViewSorting: {
            type: Boolean,
            default: false
        },
        sortable: {
            type: Boolean,
            default: false
        },
        updatableValues: {
            type: Boolean,
            default: false
        },
        showInRows: {
            type: Boolean,
            default: false
        },
        showAsList: {
            type: Boolean,
            default: false
        },
        specialIconType: {
            type: [Boolean, String],
            default: false
        },
        trackingDataLabel: {
            type: String,
            default: '',
        },
        trackingDataCategory: {
            type: String,
            default: '',
        },
        trackingDataGa4Event: {
            type: String,
            default: ''
        },
        trackingDataGa4Name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            groupData: this.singleChoice ? '' : [],
            sortableObject: undefined,
            tooltipsContent: {
                moreActions: {
                    content: 'Weitere Optionen',
                    position: 'bottom-start'
                }
            }
        }
    },
    watch: {
        groupData(newVal, oldVal) {
            if(this.singleChoiceCheckbox && oldVal !== newVal && newVal.length > 1) {
                const intersection = newVal.filter(x => oldVal.includes(x));
                if(intersection.length > 0) {
                    this.groupData = newVal.filter(x => !intersection.includes(x))
                } 
            }
        },
        values(newVal) {
            if(this.updatableValues) {
                this.setInitialValues(newVal)
            }
        }
    },
    computed: {
        isSafari() {
            return safariBrowser() ? true: false;
        }
    },
    created() {
        this.setInitialValues(this.values);
    },
    mounted() {
        if(this.sortable) {
            this.initSortable();
        }
    },
    beforeUnmount() {
        if(this.sortable && this.sortableObject) {
            this.destroySortable();
        }
    },
    methods: {
        checkboxGroupChangeHandler(data, event) {
            this.emitChange();
            if(this.trackingDataLabel && event || this.trackingDataCategory && event) 
                trackEvent({ category: this.trackingDataCategory, action: 'Settings', label: this.trackingDataLabel ? this.trackingDataLabel + ': ' + data.trackingLabel : data.trackingLabel });
        },
        checkboxChangeHandler(data, event) {
            if(this.trackingDataLabel && event || this.trackingDataCategory && event) {
                trackEvent({ category: this.trackingDataCategory, action: 'Settings', label: this.trackingDataLabel ? this.trackingDataLabel + ': ' + data.trackingLabel : data.trackingLabel });
            }

            let trackingValue = data.trackingLabel ? data.trackingLabel.replace('&', "and").replace(/ /g, "_").toLowerCase() : '';
            const tracking2Value = this.trackingDataLabel ? this.trackingDataLabel.replace(/ /g, "_").toLowerCase() : '';

            if(this.trackingDataGa4Event && event) {
                trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: trackingValue, ga4Parameter2Name: 'tab', ga4Parameter2Value: tracking2Value, ga4Event: this.trackingDataGa4Event || '-'})
            } else if(this.trackingDataCategory && event) {
                const trackingCategory = this.trackingDataCategory === 'Charging Stations' ? 'Charging Station' : this.trackingDataCategory;
                const ga4Event =  this.trackingDataGa4Name ? this.trackingDataGa4Name : trackingCategory.replace(/ /g, "_").toLowerCase();
                if(trackingValue.includes('typ')) trackingValue = trackingValue.replace('typ', 'type');
                trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: trackingValue, ga4Event: ga4Event})
            }
        },
        actionsClickHandler(e) {
            e.preventDefault()
            e.stopPropagation()
        },
        actionsOptionClickHandler(eventName, value) {
            this.$emit(eventName, value)
        },
        setInitialValues(values) {
            if(this.singleChoice) {
                this.groupData = values;
            } else if (this.outputArray) {
                this.groupData = values;
            } else if(this.singleChoiceCheckbox) {
                this.groupData = [values]
            } else {
                for(let key in values) {
                    if(values[key]) {
                        this.groupData.push(key);
                    }
                }
            }
        },
        emitChange() {
            let output;
            if(this.singleChoice) {
                output = this.groupData
            } else if(this.singleChoiceCheckbox) {
                output = this.groupData.length > 0 ? this.groupData[0] : ''
            } else if(this.outputArray) {
                output = this.keepViewSorting ? this.sortArrayByView() : this.sortArrayAlphabetically();
            } else {
                output = {};
                this.options.forEach(option => {
                    output[option.value] = this.groupData.includes(option.value)
                });
            }
            this.$emit('change', output);
        },

        sortArrayAlphabetically() {
            return this.groupData.slice().sort((a, b) => a.localeCompare(b));
        },

        sortArrayByView() {
            return sortArrayByObject(this.groupData.slice(), this.options, 'value');
        },
        initSortable() {
            let self = this;
            const checkboxGroupEl = this.$refs['checkboxGroup'].$el;
            this.sortableObject = Sortable.create(checkboxGroupEl, {
                animation: 150,
                handle: '.smr-choice-group__item__drag-handle',
                onEnd(e) {
                    self.moveOption(e.oldIndex, e.newIndex);
                },
            });
        },
        moveOption(oldIndex, newIndex) {
            this.options.splice(newIndex, 0, this.options.splice(oldIndex, 1)[0]);
            this.emitChange();
            if(newIndex === 0 && this.trackingDataLabel === 'General') {
                trackEvent({ category: 'Route Planner', action: 'Settings', label: 'General: Move: ' + this.options[newIndex].trackingLabel });
                const trackingValue = this.options[newIndex].trackingLabel ? this.options[newIndex].trackingLabel.replace(/ /g, "_").toLowerCase() : '-';
                const tracking2Value = this.trackingLabel ? this.trackingLabel.replace(/ /g, "_").toLowerCase() : 'general';
                trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: `move-${trackingValue}`, ga4Parameter2Name: 'tab', ga4Parameter2Value: tracking2Value, ga4Event: this.trackingDataGa4Event || '-'})
            }
        },
        destroySortable() {
            this.sortableObject.destroy();
        },
    }
}
</script>

<style lang="scss">
.smr-choice-group {
    $block: &;
    position: relative;

    &.as-rows {
        .el-checkbox-group,
        .el-radio-group {
            @include mq(tablet) {
                column-count: 1;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 6px;
            }
        }
        .el-checkbox,
        .el-radio {
            @include mq(tablet) {
                margin-bottom: 0 !important;
            }
        }
    }

     &.as-list {
        #{$block} {
             &__radio, &__checkbox {
                margin-bottom: 0;

                &:not(:last-of-type) {
                    border-bottom: 1px solid $color-black-005;
                }
            }
         }
       .el-radio-group {
            column-count: 1;
            display: grid;
            grid-template-columns: 1fr;
        }
        .el-radio {
            &.is-bordered {
                min-height: 44px !important;
            }
            margin-bottom: 0 !important;
            border: none;
            border-radius: 0 !important;
            padding: 4px 0 3px 0 !important;

            .no-touch &:hover {
                border-color: $color-black-005;

               .el-radio__inner {
                    border-color: $color-black;
                }
            }
        }
    }

    &__item {
        &__image {
            width: 34px;
            height: 34px;
            margin-right: 16px;
            flex-shrink: 0;
        }
        &__icon {
            width: 32px;
            height: 32px;
            margin-right: 12px;
            flex-shrink: 0;
            color: $color-grey-dark;
        }
        &__text {
            flex-grow: 1;
            .sublabel {
                display: block;
            }
        }
        &__drag-handle {
            transition: 0.2s;
            flex-shrink: 0;
            color: $color-grey;
            cursor: move;
            @include mq(desktop) {
                opacity: 0;
            }
            .is-disabled & {
                opacity: 0;
            }
            .sortable-chosen &,
            &:hover {
                color: $color-black;
                cursor: move;
            }
        }
        &__actions {
            position: relative;
            flex-shrink: 0;

            .no-touch & {
                opacity: 0;
                pointer-events: none;
                transition: 0.2s;
            }

            svg {
                color: $color-grey;
            }
        }
    }
    .el-checkbox-group,
    .el-radio-group {
        display: block;
        @include mq(tablet) {
            column-count: 2;
            column-gap: 6px;
        }
    }
    .el-checkbox,
    .el-radio {
        margin-right: 0;
        margin-left: 0 !important;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        white-space: initial;
        break-inside: avoid;
        &:not(:last-child) {
            margin-bottom: 6px;
        }
        &.is-bordered {
            transition: border-color 0.2s;
            min-height: 44px;
            height: auto;
            padding: 4px 16px 3px 16px;
            border-color: $color-black-005;
            border-radius: 6px;
            @include mq($until: tablet) {
                min-height: 54px;
            }
        }
        &.is-disabled {
            pointer-events: none;

            &.el-tooltip {
                pointer-events: all;
                cursor: default;

                * {
                    cursor: default;
                }
            }
        }
        &.sortable-ghost {
            opacity: 0.3;
        }
        &.has-icon {
            min-height: 54px;
        }
        &.increased-padding {
            padding-top: 7px;
            padding-bottom: 6px;
        }
        &:hover {
            border-color: $color-black-02;
            .el-checkbox{
                &__inner {
                    border-color: $color-black;
                }
            } 
            #{$block}{
                &__item {
                    &__drag-handle {
                        opacity: 1;
                    }
                    &__actions {
                        opacity: 1;
                        pointer-events: auto;
                    }
                }
            }
        }

        &.is-checked {
            .el-checkbox,
            .el-radio{
                &__inner {
                    background-color: $color-blue-light;
                    border-color: $color-blue-light;
                }
                &__label {
                    color: $color-black;
                    font-weight: $font-weight-regular;
                }
            }
        }
        &__input {
            &.is-focus {
                .el-checkbox,
                .el-radio{
                    &__inner {
                        border-color: $color-black;
                    }
                    &__label {
                        color: $color-black;
                        font-weight: $font-weight-regular;
                    }
                }
            }
            &.is-focus.is-checked {
                .el-checkbox,
                .el-radio{
                    &__inner {
                        border-color: $color-blue-light;
                    }
                }
            }
            &.is-disabled {
                .el-checkbox,
                .el-radio{
                    &__inner {
                        background-color: transparent;
                    }
                }
                // & + .el-checkbox{
                //     &__label {
                //         // color: $color-black-05 !important;
                //         .smr-choice-group__item__image {
                //             // opacity: 0.5;
                //         }
                //     }
                // }
                &.is-checked {
                    .el-checkbox,
                    .el-radio{
                        &__inner {
                            background-color: $color-grey;
                            border-color: $color-grey;
                            &::after {
                                border-color: white;
                            }
                        }
                    }
                    & + .el-checkbox{
                        &__label {
                            color: $color-black;
                        }
                    }
                }
            }
        }
        &__label {
            transition: color 0.25s;
            padding-left: 0;
            color: $color-black;
            font-weight: $font-weight-regular;
            font-size: 15px;
            display: flex;
            align-items: center;
            padding-right: 12px;
            flex-grow: 1;
        }
        &__inner {
            width: 17px;
            height: 17px;
            border: 2px solid $color-grey;
            border-radius: 3px;
            display: block;
            &::after {
                border-width: 2px;
            }
        }
    }
    .el-radio {    
        &__inner {
            border-radius: 100%;
            width: 18px;
            height: 18px;
            &::after {
                border-width: 0;
                width: 7px;
                height: 7px;
            }
        }
    }

    &__checkbox, &__radio {
        break-inside: avoid;
        page-break-inside: avoid; 
        -webkit-column-break-inside: avoid;
        
        &:not(:last-child) {
            margin-bottom: 6px;
        }

        &--safari {
            display: flex;
            padding-bottom: 6px;

            label {
                flex: 1;
            }

            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }
}
</style>